import { ChevronUpIcon } from '@heroicons/react/outline'
import useScrollToTop from 'hooks/useScrollToTop';
import React, { useEffect, useState } from 'react'

export default function GoUpComponent() {
  const [isVisible, setIsVisible] = useState(false);
  const { goUp } = useScrollToTop();

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <div className={`
    absolute
    md:bottom-[40px]  
    md:-right-7
    right-4
    md:w-[58px] md:h-[37px] 
    h-[37px] 
    w-[39px] 
    border-[1px] rounded-lg border-[#1B70ED]
    flex items-center justify-center
    bg-white
    cursor-pointer`}
    onClick={goUp}
    >
      <ChevronUpIcon width={"20px"} height={"20px"} color='#1B70ED' />
    </div>
  )
}
